// src:- https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/

export const downloadCSV = async (blob, name = 'virbac_file') => {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  // var newBlob = new Blob([blob], {type: "text/csv"})

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
	// @ts-expect-error - msSaveOrOpenBlob is only present in old IE browsers
  if (window?.navigator?.msSaveOrOpenBlob) {
		// @ts-expect-error - msSaveOrOpenBlob is only present in old IE browsers
    window.navigator.msSaveOrOpenBlob(blob)
    return
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = data
  link.download=`${name}.csv`
  link.click()
  setTimeout(function() {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data)
  }, 100)
}
